/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Template_Aspect_Facebook_PostInputs */

const cs_template_aspect_facebook_post = /** @type {(inputs: Template_Aspect_Facebook_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook příspěvek`)
};

const en_template_aspect_facebook_post = /** @type {(inputs: Template_Aspect_Facebook_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facebook post`)
};

/**
* | output |
* | --- |
* | "Facebook post" |
*
* @param {Template_Aspect_Facebook_PostInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const template_aspect_facebook_post = /** @type {((inputs?: Template_Aspect_Facebook_PostInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Template_Aspect_Facebook_PostInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_template_aspect_facebook_post(inputs)
	return cs_template_aspect_facebook_post(inputs)
});